import { Button, Checkbox, Modal, Space } from '@mantine/core'
import SubscriptionModel from 'engine/workspaces/SubscriptionModel'
import { observer } from 'mobx-react-lite'
import { DateInput } from '@mantine/dates'
import { useState } from 'react'
import dayjs from 'dayjs'
import NotificationService from 'services/NotificationService'

type WorkspacesListItemExtendFreeTrialModalProps = {
  opened: boolean
  onClose: () => void
  subscription: SubscriptionModel
}

export default observer(function WorkspacesListItemExtendFreeTrialModal(
  props: WorkspacesListItemExtendFreeTrialModalProps,
) {
  const [value, setValue] = useState<Date | null>(null)
  const [haveMadeWithScribe, setHaveMadeWithScribe] = useState<boolean>(true)
  const [submitting, setSubmitting] = useState<boolean>(false)
  // Extending replaces the trial with a new one ending on the picked date, so a
  // date on or before the current end would silently keep (or shorten) it.
  const currentEndsAt =
    props.subscription?.kind === 'free_trial' ? props.subscription.endsAt : null
  const weekFromNow = dayjs().add(7, 'day')
  const minDate =
    currentEndsAt && currentEndsAt.add(1, 'day').isAfter(weekFromNow)
      ? currentEndsAt.add(1, 'day')
      : weekFromNow
  return (
    <Modal
      opened={props.opened}
      onClose={props.onClose}
      title={
        props.subscription?.kind === 'free_trial'
          ? 'Extend trial'
          : 'New free trial'
      }
      centered
    >
      <DateInput
        value={value}
        onChange={(value) => setValue(value ? new Date(value) : null)}
        label="End date"
        placeholder="End date"
        description={
          currentEndsAt
            ? `Currently ends on ${currentEndsAt.format('DD/MM/YYYY')}`
            : undefined
        }
        minDate={minDate.startOf('day').toDate()}
      />
      <Space h="md" />
      <Checkbox
        label="Have made with Scribe watermark"
        checked={haveMadeWithScribe}
        onChange={(event) => setHaveMadeWithScribe(event.currentTarget.checked)}
      />
      <Space h="md" />
      <Button
        disabled={!value || dayjs(value).isBefore(minDate, 'day')}
        loading={submitting}
        onClick={async () => {
          if (!value) return
          setSubmitting(true)
          const extended = await props.subscription.extendFreeTrial(
            dayjs(value),
            haveMadeWithScribe,
          )
          setSubmitting(false)
          if (!extended) {
            NotificationService.error('The trial could not be extended')
            return
          }
          NotificationService.success(
            `Trial extended until ${dayjs(value).format('DD/MM/YYYY')}`,
          )
          props.onClose()
        }}
      >
        Extend
      </Button>
    </Modal>
  )
})
